import React from "react";
import { Link, List, ListItem, Paper, Typography } from "@material-ui/core";

export default function Ref({data}) {
  const {ref, tool} = data.refs[0];
  return (
    <div id="ref">
      <div className="bg" />
      <div className="refs">
        <Paper className="ref">
          <Typography className="title" align="center" variant="h2">
            References
          </Typography>
          <List>
            {
              (ref[0].item||[]).map((item) => (
                <ListItem>
                  <Link href={item.url[0]}>{item.text[0]}</Link>
                </ListItem>
              ))
            }
          </List>  
        </Paper>
        <Paper className="tool">
          <Typography className="title" align="center" variant="h2">
            Tools & Platforms
          </Typography>
          <List>
            {
              (tool[0].item||[]).map((item) => (
                <ListItem>
                  <Link href={item.url[0]}>{item.text[0]}</Link>
                </ListItem>
              ))
            }
          </List>  
          </Paper>
      </div>
    </div>
  );
}
